import '@innovatrics/dot-auto-capture-ui/document';
import type { DocumentUiConfiguration, HTMLDocumentUiElement } from '@innovatrics/dot-auto-capture-ui/document';

import { useEffect } from 'react';

export const DocumentCameraUi = (props: DocumentUiConfiguration) => {
  useEffect(() => {
    const uiElement = document.getElementById('x-dot-document-auto-capture-ui') as HTMLDocumentUiElement | null;

    if (uiElement) {
      uiElement.configuration = props;
    }
  });

  return <x-dot-document-auto-capture-ui id="x-dot-document-auto-capture-ui" />;
};
